import React, { useState, useEffect, useRef } from "react";
// import { FaSort, FaSortUp, FaSortDown, FaTimes } from "react-icons/fa";
import { CloseOutlined } from "@ant-design/icons";

const DynamicSortDropdown = ({
  sortOptions,
  data,
  onSortChange,
  currentSortField,
  currentSortOrder,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null); // To detect clicks outside the dropdown

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Function to apply sorting or clear sorting
  const applySorting = (field) => {
    let sortedData = [...data];

    const newSortOrder =
      currentSortField === field && currentSortOrder === "asc" ? "desc" : "asc";
    const statusOrder = {
      // completed: 1,
      // ongoing: 2,
      // "just-released": 3,
      // overdue: 4,
      // review: 5,
      ongoing: 1,
      "just-released": 2,
      overdue: 3,
      review: 4,
    };

    sortedData.sort((a, b) => {
      const valueA = a.props[field];
      const valueB = b.props[field];

      if (valueA === undefined || valueA === null || valueA === "") {
        return 1;
      }
      if (valueB === undefined || valueB === null || valueB === "") {
        return -1;
      }

      if (field === "status") {
        const orderA = statusOrder[valueA.toLowerCase()];
        const orderB = statusOrder[valueB.toLowerCase()];

        if (newSortOrder === "asc") {
          return orderA - orderB;
        } else {
          return orderB - orderA;
        }
      }

      if (newSortOrder === "asc") {
        return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
      }

      return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
    });

    console.log('sss sortedData', sortedData)

    onSortChange(sortedData, field, newSortOrder);
  };

  // Function to clear sorting
  const clearSorting = () => {
    onSortChange(data, null, null); // Reset sorting (deselect filter)
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="sort-container" ref={dropdownRef}>
      {/* Toggle button for sorting dropdown */}
      <button onClick={toggleDropdown} className="sort-icon">
        {/* Display the appropriate icon based on sorting state */}
        <img src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/myTaskSwitchVerticalIcon.svg"  />
      </button>

      {dropdownOpen && (
        <div className="dropdown">
          <p
            style={{
              fontWeight: "400",
              fontSize: "14px",
              lineHeight: "100%",
              color: "#888888",
              marginBottom: "5px",
          }}
          >SORT BY:</p>
          <ul>
            {sortOptions.map((option) => (
              <li
                key={option.field}
                onClick={() => applySorting(option.field)}
                className={option.field === currentSortField ? "selected" : ""}
                style={{
                  display: option.field === currentSortField && currentSortOrder !== null ?  "flex" : ""
                }}
              >
                {option.label}

                {option.field === currentSortField && currentSortOrder !== null && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation(); 
                      clearSorting();
                    }}
                    className="clear-sort-btn"
                  >
                    {/* <FaTimes /> */}
                    <CloseOutlined />
                  </button>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DynamicSortDropdown;
